// extracted by mini-css-extract-plugin
export default {"mainContainer":"MultipleUsers_mainContainer__gL6RQ","stickyHeader":"MultipleUsers_stickyHeader__9pjX7","userInfoCard":"MultipleUsers_userInfoCard__Qvndx"};